export var commonTerms = [
	{ "@id": "/c/en/seeing_art", label: "seeing art" },
	{ "@id": "/c/en/exercising", label: "Exercising" },
	{ "@id": "/c/en/visit_museum", label: "visit a museum" },
	{ "@id": "/c/en/kill", label: "kill someone" },
	{ "@id": "/c/en/reading_book", label: "reading a book" },
	{ "@id": "/c/en/think", label: "think" },
	{ "@id": "/c/en/go_for_walk", label: "go for a walk" },
	{ "@id": "/c/en/theatre", label: "the theatre" },
	{ "@id": "/c/en/drinking_alcohol", label: "drinking alcohol" },
	{ "@id": "/c/en/boat", label: "a boat" },
	{ "@id": "/c/en/cleaning_house", label: "be cleaning a house" },
	{ "@id": "/c/en/container", label: "container" },
	{ "@id": "/c/en/reading_newspaper", label: "reading a newspaper" },
	{ "@id": "/c/en/shopping", label: "shopping" },
	{ "@id": "/c/en/getting_onto_web", label: "getting onto the web" },
	{ "@id": "/c/en/trash", label: "trash" },
	{ "@id": "/c/en/advancing_into_battle", label: "advancing into battle" },
	{ "@id": "/c/en/home", label: "home" },
	{ "@id": "/c/en/sex", label: "Sex" },
	{ "@id": "/c/en/study", label: "study" },
	{ "@id": "/c/en/ficus", label: "a ficus" },
	{ "@id": "/c/en/friend", label: "a friend" },
	{ "@id": "/c/en/going_for_swim", label: "going for a swim" },
	{ "@id": "/c/en/finding_information", label: "finding information" },
	{ "@id": "/c/en/chat_with_friends", label: "chat with friends" },
	{ "@id": "/c/en/start_fire", label: "start a fire" },
	{ "@id": "/c/en/apartment", label: "an apartment" },
	{ "@id": "/c/en/shark", label: "a shark" },
	{ "@id": "/c/en/breathe", label: "breathe" },
	{ "@id": "/c/en/writing", label: "writing" },
	{ "@id": "/c/en/computers", label: "computers" },
	{ "@id": "/c/en/going_to_work", label: "going to work" },
	{ "@id": "/c/en/listen", label: "listen" },
	{ "@id": "/c/en/help", label: "help" },
	{ "@id": "/c/en/reading", label: "reading" },
	{ "@id": "/c/en/painting", label: "painting" },
	{ "@id": "/c/en/going_for_walk", label: "going for a walk" },
	{ "@id": "/c/en/cutting_hair", label: "cutting hair" },
	{ "@id": "/c/en/listen_to_music", label: "listen to music" },
	{ "@id": "/c/en/sun", label: "sun" },
	{ "@id": "/c/en/fencing", label: "fencing" },
	{ "@id": "/c/en/fire", label: "fire" },
	{ "@id": "/c/en/table", label: "a table" },
	{ "@id": "/c/en/look_better", label: "look better" },
	{ "@id": "/c/en/horse", label: "horse" },
	{ "@id": "/c/en/kiss", label: "kiss someone" },
	{ "@id": "/c/en/act_in_play", label: "act in a play" },
	{
		"@id": "/c/en/keeping_things_orderly_and_tidy",
		label: "keeping things orderly and tidy"
	},
	{ "@id": "/c/en/staying_healthy", label: "staying healthy" },
	{ "@id": "/c/en/making_people_laugh", label: "making people laugh" },
	{ "@id": "/c/en/television", label: "television" },
	{ "@id": "/c/en/smoke", label: "smoke" },
	{ "@id": "/c/en/city", label: "city" },
	{ "@id": "/c/en/dog", label: "dog" },
	{ "@id": "/c/en/fall", label: "fall" },
	{ "@id": "/c/en/playing_tennis", label: "playing tennis" },
	{ "@id": "/c/en/car", label: "car" },
	{ "@id": "/c/en/cat", label: "a cat" },
	{ "@id": "/c/en/can", label: "can" },
	{ "@id": "/c/en/making_phone_call", label: "making a phone call" },
	{ "@id": "/c/en/playing_basketball", label: "playing basketball" },
	{ "@id": "/c/en/drive_car", label: "drive a car" },
	{ "@id": "/c/en/child", label: "child" },
	{ "@id": "/c/en/talk", label: "talk" },
	{ "@id": "/c/en/working", label: "working" },
	{ "@id": "/c/en/go_on_internet", label: "go on the internet" },
	{ "@id": "/c/en/paying_bills", label: "paying bills" },
	{ "@id": "/c/en/go_to_work", label: "go to work" },
	{ "@id": "/c/en/falling", label: "falling" },
	{ "@id": "/c/en/animals", label: "animals" },
	{ "@id": "/c/en/bedroom", label: "a bedroom" },
	{ "@id": "/c/en/drawer", label: "a drawer" },
	{ "@id": "/c/en/riding_bicycle", label: "riding a bicycle" },
	{ "@id": "/c/en/bald_eagle", label: "a bald eagle" },
	{ "@id": "/c/en/pool", label: "a pool" },
	{ "@id": "/c/en/sitting_quietly", label: "sitting quietly" },
	{ "@id": "/c/en/purse", label: "purse" },
	{ "@id": "/c/en/washing_clothes", label: "washing clothes" },
	{ "@id": "/c/en/eat_breakfast", label: "eat breakfast" },
	{ "@id": "/c/en/lizard", label: "a lizard" },
	{ "@id": "/c/en/taking_bus", label: "taking the bus" },
	{ "@id": "/c/en/playing_games", label: "playing games" },
	{ "@id": "/c/en/surprising", label: "surprising someone" },
	{ "@id": "/c/en/town", label: "town" },
	{ "@id": "/c/en/playing_football", label: "playing football" },
	{ "@id": "/c/en/bridge", label: "bridge" },
	{ "@id": "/c/en/sing", label: "sing" },
	{ "@id": "/c/en/travel", label: "travel" },
	{ "@id": "/c/en/sending_e_mail", label: "sending e-mail" },
	{ "@id": "/c/en/finger", label: "finger" },
	{ "@id": "/c/en/snake", label: "a snake" },
	{ "@id": "/c/en/play", label: "play" },
	{ "@id": "/c/en/going_on_vacation", label: "going on a vacation" },
	{ "@id": "/c/en/make_people_laugh", label: "make people laugh" },
	{ "@id": "/c/en/play_game", label: "play a game" },
	{ "@id": "/c/en/eat", label: "eat" },
	{ "@id": "/c/en/go_to_mall", label: "go to the mall" },
	{ "@id": "/c/en/newspaper", label: "the newspaper" },
	{ "@id": "/c/en/cats", label: "Cats" },
	{ "@id": "/c/en/writing_program", label: "writing a program" },
	{ "@id": "/c/en/pilots", label: "pilots" },
	{ "@id": "/c/en/buying", label: "buying" },
	{ "@id": "/c/en/house", label: "house" },
	{ "@id": "/c/en/bringing_home_fish", label: "bringing home some fish" },
	{ "@id": "/c/en/get_fit", label: "get fit" },
	{ "@id": "/c/en/having_rest", label: "having a rest" },
	{ "@id": "/c/en/killing", label: "killing someone" },
	{ "@id": "/c/en/buy_house", label: "buy a house" },
	{ "@id": "/c/en/light_match", label: "light a match" },
	{ "@id": "/c/en/one", label: "one" },
	{ "@id": "/c/en/losing_weight", label: "losing weight" },
	{
		"@id": "/c/en/getting_physical_activity",
		label: "getting some physical activity"
	},
	{ "@id": "/c/en/swim", label: "swim" },
	{ "@id": "/c/en/answering_questions", label: "answering questions" },
	{ "@id": "/c/en/eat_apple", label: "eat an apple" },
	{ "@id": "/c/en/taking_bath", label: "taking a bath" },
	{ "@id": "/c/en/sleeping", label: "sleeping" },
	{ "@id": "/c/en/getting_fit", label: "getting fit" },
	{ "@id": "/c/en/get_job", label: "get a job" },
	{ "@id": "/c/en/ride_horse", label: "ride a horse" },
	{ "@id": "/c/en/sea", label: "sea" },
	{ "@id": "/c/en/having_party", label: "having a party" },
	{ "@id": "/c/en/backpack", label: "a backpack" },
	{ "@id": "/c/en/skate", label: "skate" },
	{ "@id": "/c/en/designing_software", label: "designing software" },
	{ "@id": "/c/en/eating_apple", label: "eating an apple" },
	{ "@id": "/c/en/fighting_war", label: "fighting war" },
	{ "@id": "/c/en/dressing_nice", label: "dressing nice" },
	{ "@id": "/c/en/take_shower", label: "take a shower" },
	{ "@id": "/c/en/talking", label: "talking" },
	{ "@id": "/c/en/selling_new_book", label: "selling your new book" },
	{ "@id": "/c/en/fight_enemy", label: "fight the enemy" },
	{ "@id": "/c/en/united_states", label: "the united states" },
	{ "@id": "/c/en/motel", label: "a motel" },
	{ "@id": "/c/en/going_for_run", label: "going for a run" },
	{ "@id": "/c/en/food", label: "food" },
	{ "@id": "/c/en/cow", label: "cow" },
	{ "@id": "/c/en/world", label: "the world" },
	{ "@id": "/c/en/clean_clothes", label: "clean clothes" },
	{ "@id": "/c/en/sleep", label: "sleep" },
	{
		"@id": "/c/en/looking_through_telescope",
		label: "looking through a telescope"
	},
	{ "@id": "/c/en/playing_piano", label: "playing the piano" },
	{ "@id": "/c/en/moon", label: "the moon" },
	{
		"@id": "/c/en/meet_interesting_people",
		label: "meet interesting people"
	},
	{ "@id": "/c/en/english_language", label: "English language" },
	{ "@id": "/c/en/church", label: "church" },
	{ "@id": "/c/en/dancing", label: "dancing" },
	{ "@id": "/c/en/weeding_garden", label: "weeding the garden" },
	{ "@id": "/c/en/read_book", label: "read a book" },
	{ "@id": "/c/en/get_drunk", label: "get drunk" },
	{ "@id": "/c/en/live", label: "live" },
	{ "@id": "/c/en/do_housework", label: "do the housework" },
	{ "@id": "/c/en/students", label: "students" },
	{ "@id": "/c/en/climbing_mountain", label: "climbing a mountain" },
	{ "@id": "/c/en/getting_up_early", label: "getting up early" },
	{ "@id": "/c/en/going_to_school", label: "going to school" },
	{ "@id": "/c/en/boredom", label: "boredom" },
	{ "@id": "/c/en/wash_hands", label: "wash your hands" },
	{ "@id": "/c/en/clean", label: "clean" },
	{ "@id": "/c/en/party", label: "party" },
	{ "@id": "/c/en/war", label: "war" },
	{ "@id": "/c/en/have_fun", label: "have some fun" },
	{ "@id": "/c/en/air", label: "Air" },
	{ "@id": "/c/en/human", label: "human" },
	{ "@id": "/c/en/staying_in_bed", label: "staying in bed" },
	{ "@id": "/c/en/kissing", label: "kissing" },
	{ "@id": "/c/en/playing_baseball", label: "playing baseball" },
	{ "@id": "/c/en/hearing_music", label: "hearing music" },
	{ "@id": "/c/en/write_story", label: "write a story" },
	{ "@id": "/c/en/roof", label: "a roof" },
	{ "@id": "/c/en/dance", label: "dance" },
	{ "@id": "/c/en/enjoyment", label: "enjoyment" },
	{ "@id": "/c/en/going_on_strike", label: "going on strike" },
	{ "@id": "/c/en/death", label: "death" },
	{ "@id": "/c/en/find_lost_item", label: "find a lost item" },
	{ "@id": "/c/en/ice", label: "Ice" },
	{ "@id": "/c/en/traveling", label: "traveling" },
	{ "@id": "/c/en/learn_language", label: "learn a language" },
	{ "@id": "/c/en/spending_money", label: "spending money" },
	{ "@id": "/c/en/going_to_party", label: "going to a party" },
	{ "@id": "/c/en/using_television", label: "using a television" },
	{ "@id": "/c/en/supermarket", label: "the supermarket" },
	{ "@id": "/c/en/attend_meeting", label: "attend a meeting" },
	{ "@id": "/c/en/school", label: "a school" },
	{ "@id": "/c/en/diving", label: "diving" },
	{ "@id": "/c/en/fix_computer", label: "fix a computer" },
	{ "@id": "/c/en/doctor", label: "doctor" },
	{ "@id": "/c/en/hear_music", label: "hear music" },
	{ "@id": "/c/en/bathing", label: "bathing" },
	{ "@id": "/c/en/going_to_market", label: "going to market" },
	{ "@id": "/c/en/reading_to_children", label: "reading to your children" },
	{ "@id": "/c/en/go_to_restaurant", label: "go to a restaurant" },
	{ "@id": "/c/en/ocean", label: "any ocean" },
	{ "@id": "/c/en/entertainment", label: "entertainment" },
	{ "@id": "/c/en/desk", label: "a desk" },
	{ "@id": "/c/en/play_games", label: "play games" },
	{ "@id": "/c/en/cooking_meal", label: "cooking a meal" },
	{ "@id": "/c/en/kitten", label: "a kitten" },
	{ "@id": "/c/en/drink", label: "drink" },
	{ "@id": "/c/en/potato", label: "a potato" },
	{ "@id": "/c/en/cooling_off", label: "cooling off" },
	{ "@id": "/c/en/airport", label: "an airport" },
	{ "@id": "/c/en/stand_up", label: "stand up" },
	{ "@id": "/c/en/surf_web", label: "surf the web" },
	{ "@id": "/c/en/judge", label: "judge" },
	{ "@id": "/c/en/love", label: "Love" },
	{ "@id": "/c/en/walk", label: "walk" },
	{ "@id": "/c/en/entertain", label: "entertain" },
	{ "@id": "/c/en/play_game_of_chess", label: "play the game of chess" },
	{ "@id": "/c/en/space", label: "space" },
	{ "@id": "/c/en/write_letter", label: "write a letter" },
	{ "@id": "/c/en/standing_up", label: "standing up" },
	{ "@id": "/c/en/water_plant", label: "water a plant" },
	{ "@id": "/c/en/kitchen", label: "the kitchen" },
	{ "@id": "/c/en/read_newspaper", label: "read the newspaper" },
	{ "@id": "/c/en/playing", label: "playing" },
	{ "@id": "/c/en/chopping_firewood", label: "chopping firewood" },
	{ "@id": "/c/en/hospital", label: "a hospital" },
	{ "@id": "/c/en/cupboard", label: "the cupboard" },
	{ "@id": "/c/en/going_for_jog", label: "going for a jog" },
	{ "@id": "/c/en/fishing", label: "fishing" },
	{ "@id": "/c/en/resting", label: "resting" },
	{ "@id": "/c/en/light_fire", label: "light a fire" },
	{ "@id": "/c/en/have_lunch", label: "have lunch" },
	{ "@id": "/c/en/buy_food", label: "buy food" },
	{ "@id": "/c/en/eating", label: "eating" },
	{ "@id": "/c/en/fly_kite", label: "fly a kite" },
	{ "@id": "/c/en/receiving_degree", label: "receiving a degree" },
	{ "@id": "/c/en/mall", label: "a mall" },
	{ "@id": "/c/en/lose_weight", label: "lose weight" },
	{ "@id": "/c/en/cool_off", label: "cool off" },
	{ "@id": "/c/en/getting_divorce", label: "getting a divorce" },
	{ "@id": "/c/en/send_e_mail", label: "send e-mail" },
	{ "@id": "/c/en/surprise", label: "surprise" },
	{ "@id": "/c/en/reaching_impasse", label: "reaching an impasse" },
	{ "@id": "/c/en/basement", label: "the basement" },
	{ "@id": "/c/en/beaver", label: "a beaver" },
	{ "@id": "/c/en/plate", label: "plate" },
	{ "@id": "/c/en/actor", label: "an actor" },
	{ "@id": "/c/en/typing", label: "typing" },
	{ "@id": "/c/en/die", label: "die" },
	{ "@id": "/c/en/student", label: "a student" },
	{ "@id": "/c/en/starting_fire", label: "starting a fire" },
	{ "@id": "/c/en/movies", label: "the movies" },
	{ "@id": "/c/en/entertaining", label: "entertaining" },
	{ "@id": "/c/en/sit_down", label: "sit down" },
	{ "@id": "/c/en/people", label: "people" },
	{ "@id": "/c/en/play_cards", label: "play cards" },
	{ "@id": "/c/en/play_tennis", label: "play tennis" },
	{ "@id": "/c/en/getting_exercise", label: "getting exercise" },
	{ "@id": "/c/en/wash_clothes", label: "wash clothes" },
	{ "@id": "/c/en/watch_tv", label: "watch TV" },
	{ "@id": "/c/en/kids", label: "kids" },
	{ "@id": "/c/en/starting_family", label: "starting a family" },
	{ "@id": "/c/en/wood", label: "wood" },
	{ "@id": "/c/en/ride_bicycle", label: "ride a bicycle" },
	{ "@id": "/c/en/work", label: "work" },
	{ "@id": "/c/en/getting_wet", label: "getting wet" },
	{ "@id": "/c/en/having_fun", label: "having fun" },
	{ "@id": "/c/en/fun", label: "fun" },
	{ "@id": "/c/en/visiting_museum", label: "visiting a museum" },
	{ "@id": "/c/en/stress", label: "stress" },
	{ "@id": "/c/en/driving_car", label: "driving a car" },
	{ "@id": "/c/en/giving_gift", label: "giving a gift" },
	{ "@id": "/c/en/buy_products", label: "buy products" },
	{ "@id": "/c/en/dying", label: "dying" },
	{ "@id": "/c/en/communicating", label: "Communicating" },
	{ "@id": "/c/en/eating_hamburger", label: "eating the hamburger" },
	{ "@id": "/c/en/chatting_with_friends", label: "chatting with friends" },
	{ "@id": "/c/en/have_shower", label: "have a shower" },
	{ "@id": "/c/en/fungus", label: "a fungus" },
	{ "@id": "/c/en/refrigerator", label: "the refrigerator" },
	{ "@id": "/c/en/office", label: "the office" },
	{ "@id": "/c/en/laugh", label: "laugh" },
	{ "@id": "/c/en/stay_healthy", label: "stay healthy" },
	{ "@id": "/c/en/driving", label: "driving" },
	{ "@id": "/c/en/music", label: "Music" },
	{ "@id": "/c/en/cars", label: "Some cars" },
	{ "@id": "/c/en/maintain_good_health", label: "maintain good health" },
	{ "@id": "/c/en/procreating", label: "procreating" },
	{ "@id": "/c/en/museum", label: "museum" },
	{ "@id": "/c/en/store", label: "store" },
	{ "@id": "/c/en/forgiving", label: "forgiving someone" },
	{ "@id": "/c/en/breathing", label: "breathing" },
	{ "@id": "/c/en/humans", label: "humans" },
	{ "@id": "/c/en/socialize", label: "socialize" },
	{ "@id": "/c/en/paint", label: "paint" },
	{ "@id": "/c/en/cooking_dinner", label: "cooking dinner" },
	{ "@id": "/c/en/surfing_web", label: "surfing the web" },
	{ "@id": "/c/en/teacher", label: "a teacher" },
	{ "@id": "/c/en/having_lunch", label: "having lunch" },
	{ "@id": "/c/en/write", label: "write" },
	{ "@id": "/c/en/studying", label: "studying" },
	{ "@id": "/c/en/playing_poker", label: "playing poker" },
	{ "@id": "/c/en/shelf", label: "a shelf" },
	{ "@id": "/c/en/children", label: "children" },
	{ "@id": "/c/en/get_clean", label: "you get clean" },
	{ "@id": "/c/en/mouth", label: "your mouth" },
	{ "@id": "/c/en/have_party", label: "have a party" },
	{ "@id": "/c/en/play_piano", label: "play a piano" },
	{ "@id": "/c/en/happiness", label: "happiness" },
	{ "@id": "/c/en/buy", label: "buy something" },
	{ "@id": "/c/en/having_conversation", label: "having a conversation" },
	{ "@id": "/c/en/lighting_fire", label: "lighting a fire" },
	{ "@id": "/c/en/read", label: "read" },
	{ "@id": "/c/en/tree", label: "tree" },
	{ "@id": "/c/en/tell_story", label: "tell a story" },
	{ "@id": "/c/en/cooking", label: "cooking" },
	{ "@id": "/c/en/water", label: "water" },
	{ "@id": "/c/en/country", label: "country" },
	{ "@id": "/c/en/beach", label: "beach" },
	{ "@id": "/c/en/growing_vegetables", label: "growing vegetables" },
	{ "@id": "/c/en/sky", label: "sky" },
	{ "@id": "/c/en/singing", label: "Singing" },
	{ "@id": "/c/en/remembering", label: "remembering something" },
	{ "@id": "/c/en/bed", label: "bed" },
	{ "@id": "/c/en/money", label: "money" },
	{ "@id": "/c/en/running_in_marathon", label: "running in a marathon" },
	{ "@id": "/c/en/program", label: "a program" },
	{ "@id": "/c/en/writing_story", label: "writing a story" },
	{ "@id": "/c/en/eating_breakfast", label: "eating breakfast" },
	{ "@id": "/c/en/improving_yourself", label: "improving yourself" },
	{ "@id": "/c/en/wiener_dog", label: "a wiener dog" },
	{ "@id": "/c/en/relax", label: "relax" },
	{ "@id": "/c/en/closet", label: "a closet" },
	{ "@id": "/c/en/bathe", label: "bathe" },
	{ "@id": "/c/en/play_chess", label: "play chess" },
	{ "@id": "/c/en/jar", label: "the jar" },
	{ "@id": "/c/en/movie", label: "a movie" },
	{ "@id": "/c/en/go_for_jog", label: "go for a jog" },
	{ "@id": "/c/en/watching_tv", label: "watching TV" },
	{ "@id": "/c/en/making_better_world", label: "making a better world" },
	{ "@id": "/c/en/socialising", label: "socialising" },
	{ "@id": "/c/en/running", label: "running" },
	{ "@id": "/c/en/getting_in_shape", label: "getting in shape" },
	{ "@id": "/c/en/person", label: "A person" },
	{ "@id": "/c/en/fox", label: "fox" },
	{ "@id": "/c/en/kill_people", label: "kill people" },
	{ "@id": "/c/en/cabinet", label: "a cabinet" },
	{ "@id": "/c/en/living", label: "living" },
	{ "@id": "/c/en/praying", label: "praying" },
	{ "@id": "/c/en/telling_story", label: "telling a story" },
	{ "@id": "/c/en/pray", label: "pray" },
	{ "@id": "/c/en/celebrate", label: "you celebrate" },
	{ "@id": "/c/en/grocery_store", label: "a grocery store" },
	{ "@id": "/c/en/dangerous", label: "dangerous" },
	{ "@id": "/c/en/forest", label: "a forest" },
	{ "@id": "/c/en/playing_violin", label: "playing the violin" },
	{ "@id": "/c/en/spend_money", label: "you spend money" },
	{ "@id": "/c/en/copulating", label: "copulating" },
	{ "@id": "/c/en/hotel", label: "a hotel" },
	{ "@id": "/c/en/go_for_swim", label: "go for a swim" },
	{ "@id": "/c/en/pleasure", label: "pleasure" },
	{ "@id": "/c/en/discovering_truth", label: "discovering the truth" },
	{
		"@id": "/c/en/one_impairment_person_might",
		label: "One impairment a person might"
	},
	{ "@id": "/c/en/line", label: "line" },
	{ "@id": "/c/en/writing_letter", label: "writing a letter" },
	{ "@id": "/c/en/sporting_goods_store", label: "a sporting goods store" },
	{ "@id": "/c/en/competing", label: "competing" },
	{ "@id": "/c/en/swimming", label: "Swimming" },
	{ "@id": "/c/en/library", label: "a library." },
	{ "@id": "/c/en/get_wet", label: "get wet" },
	{ "@id": "/c/en/design_software", label: "design software" },
	{ "@id": "/c/en/restaurant", label: "a restaurant" },
	{ "@id": "/c/en/cleaning", label: "cleaning" },
	{ "@id": "/c/en/earth", label: "earth" },
	{ "@id": "/c/en/drive", label: "drive" },
	{ "@id": "/c/en/earning_living", label: "earning a living" },
	{ "@id": "/c/en/small_dog", label: "a small dog" },
	{ "@id": "/c/en/celebrating", label: "celebrating" },
	{ "@id": "/c/en/riding_bike", label: "riding a bike" },
	{ "@id": "/c/en/hair", label: "hair" },
	{ "@id": "/c/en/getting_drunk", label: "getting drunk" },
	{ "@id": "/c/en/use_computer", label: "use a computer" },
	{ "@id": "/c/en/box", label: "box" },
	{ "@id": "/c/en/tape_television_show", label: "tape a television show" },
	{ "@id": "/c/en/pay_bills", label: "pay bills" },
	{ "@id": "/c/en/have_food", label: "have food" },
	{ "@id": "/c/en/buying_house", label: "buying a house" },
	{ "@id": "/c/en/killing_people", label: "killing people" },
	{ "@id": "/c/en/knife", label: "knife" },
	{ "@id": "/c/en/run_marathon", label: "run the marathon" },
	{ "@id": "/c/en/fridge", label: "the fridge" },
	{ "@id": "/c/en/howling_with_laughter", label: "howling with laughter" },
	{ "@id": "/c/en/play_poker", label: "play poker" },
	{ "@id": "/c/en/having_physical_exam", label: "having a physical exam" },
	{ "@id": "/c/en/book", label: "book" },
	{ "@id": "/c/en/learn", label: "learn" },
	{ "@id": "/c/en/buying_hamburger", label: "buying a hamburger" },
	{ "@id": "/c/en/becoming_inebriated", label: "becoming inebriated" },
	{ "@id": "/c/en/flirting", label: "flirting" },
	{ "@id": "/c/en/mouse", label: "a mouse" },
	{
		"@id": "/c/en/eating_in_fast_food_restaurant",
		label: "eating in a fast food restaurant"
	},
	{ "@id": "/c/en/go_to_sleep", label: "you go to sleep" },
	{ "@id": "/c/en/attending_class", label: "attending class" },
	{ "@id": "/c/en/theater", label: "the theater" },
	{ "@id": "/c/en/meet_girls", label: "meet girls" },
	{ "@id": "/c/en/run", label: "run" },
	{ "@id": "/c/en/communicate", label: "communicate" },
	{ "@id": "/c/en/books", label: "books" },
	{ "@id": "/c/en/go_to_bed", label: "go to bed" },
	{ "@id": "/c/en/join_army", label: "join the army" },
	{ "@id": "/c/en/lying", label: "lying" },
	{ "@id": "/c/en/sit_quietly", label: "sit quietly" },
	{ "@id": "/c/en/learning", label: "learning" },
	{ "@id": "/c/en/playing_game", label: "playing a game" },
	{ "@id": "/c/en/rest", label: "rest" },
	{ "@id": "/c/en/anyone", label: "anyone" },
	{ "@id": "/c/en/do_exercises", label: "do some exercises" },
	{ "@id": "/c/en/have_heart_attack", label: "have a heart attack" },
	{ "@id": "/c/en/shop", label: "shop" },
	{ "@id": "/c/en/doing_housework", label: "doing housework" },
	{ "@id": "/c/en/cook_meal", label: "cook a meal" },
	{ "@id": "/c/en/garage", label: "the garage" },
	{ "@id": "/c/en/grape", label: "grape" },
	{ "@id": "/c/en/playing_cards", label: "playing cards" },
	{ "@id": "/c/en/lie", label: "lie" },
	{ "@id": "/c/en/relaxing", label: "relaxing" },
	{ "@id": "/c/en/crab", label: "a crab" },
	{ "@id": "/c/en/sitting_down", label: "sitting down" },
	{ "@id": "/c/en/relaxation", label: "relaxation" },
	{ "@id": "/c/en/go_to_store", label: "go to the store" },
	{ "@id": "/c/en/smoking", label: "smoking" },
	{ "@id": "/c/en/painting_picture", label: "painting a picture" },
	{ "@id": "/c/en/bookstore", label: "a bookstore" },
	{ "@id": "/c/en/good", label: "good" },
	{ "@id": "/c/en/paper", label: "paper" },
	{ "@id": "/c/en/listening_to_radio", label: "listening to the radio" },
	{ "@id": "/c/en/glass", label: "glass" },
	{ "@id": "/c/en/setting_cup_on_table", label: "setting a cup on a table" },
	{ "@id": "/c/en/buying_products", label: "buying products" },
	{ "@id": "/c/en/taking_exam", label: "taking an exam" },
	{ "@id": "/c/en/hearing_news", label: "hearing the news" },
	{ "@id": "/c/en/talk_to", label: "talk to someone" },
	{ "@id": "/c/en/playing_chess", label: "playing chess" },
	{ "@id": "/c/en/fish", label: "a fish" },
	{ "@id": "/c/en/go_somewhere", label: "go somewhere" },
	{ "@id": "/c/en/watching_movie", label: "watching a movie" },
	{ "@id": "/c/en/set_cup_on_table", label: "set a cup on the table" },
	{ "@id": "/c/en/having_bath", label: "having a bath" },
	{ "@id": "/c/en/bar", label: "bar" },
	{ "@id": "/c/en/computer", label: "a computer" },
	{ "@id": "/c/en/changing_appearance", label: "changing your appearance" },
	{ "@id": "/c/en/paint_picture", label: "paint a picture" },
	{ "@id": "/c/en/commit_suicide", label: "commit suicide" },
	{ "@id": "/c/en/buying_food", label: "buying food" },
	{ "@id": "/c/en/getting_job", label: "getting a job" },
	{ "@id": "/c/en/fart", label: "fart" },
	{ "@id": "/c/en/walking", label: "Walking" },
	{ "@id": "/c/en/street", label: "street" },
	{ "@id": "/c/en/using_computer", label: "using a computer" },
	{ "@id": "/c/en/remember", label: "you remember" },
	{ "@id": "/c/en/watching_television", label: "watching television" },
	{ "@id": "/c/en/hike", label: "hike" },
	{ "@id": "/c/en/listening_to_music", label: "listening to music" },
	{ "@id": "/c/en/eat_hamburger", label: "eat a hamburger" },
	{ "@id": "/c/en/meeting_people", label: "meeting people" },
	{ "@id": "/c/en/suitcase", label: "a suitcase" },
	{ "@id": "/c/en/dogs", label: "dogs" },
	{ "@id": "/c/en/go_to_school", label: "go to school" },
	{ "@id": "/c/en/happy", label: "happy" },
	{ "@id": "/c/en/go_on_vacation", label: "go on a vacation" },
	{ "@id": "/c/en/fight_war", label: "fight war" },
	{ "@id": "/c/en/building", label: "building" },
	{ "@id": "/c/en/cook", label: "A cook" },
	{ "@id": "/c/en", label: "answer" },
	{ "@id": "/c/en/take_bath", label: "take a bath" },
	{ "@id": "/c/en/weasel", label: "a weasel" },
	{ "@id": "/c/en/clean_house", label: "a clean house" },
	{ "@id": "/c/en/bathroom", label: "a bathroom" },
	{ "@id": "/c/en/pain", label: "pain" },
	{ "@id": "/c/en/stay_in_bed", label: "stay in bed" },
	{ "@id": "/c/en/park", label: "the park" },
	{ "@id": "/c/en/learning_new", label: "learning something new" },
	{ "@id": "/c/en/drinking", label: "drinking" },
	{ "@id": "/c/en/fixing_computer", label: "fixing a computer" },
	{ "@id": "/c/en/making_friends", label: "making friends" },
	{ "@id": "/c/en/play_sports", label: "play sports" },
	{ "@id": "/c/en/apply_for_job", label: "apply for a job" },
	{ "@id": "/c/en/joining_army", label: "joining the army" },
	{ "@id": "/c/en/thinking", label: "thinking" },
	{
		"@id": "/c/en/get_physical_activity",
		label: "get some physical activity"
	},
	{ "@id": "/c/en/smile", label: "smile" },
	{ "@id": "/c/en/waking_up_in_morning", label: "waking up in the morning" },
	{ "@id": "/c/en/exercise", label: "exercise" },
	{ "@id": "/c/en/machine", label: "a machine" },
	{ "@id": "/c/en/wait_for", label: "wait for someone" },
	{ "@id": "/c/en/climb_mountain", label: "climb a mountain" },
	{ "@id": "/c/en/examining_thing", label: "examining a thing" }
];



// WEBPACK FOOTER //
// ./src/include/commonTerms.js